import React from 'react';

const Answer = (props) => {
    return (
        <p>
            {props.answer}
        </p>
    );
};

export default Answer;